/** Standard brokerage rate used on legacy qbcon.in homepage calculator */
export const BROKERAGE_RATE = 0.015

export const CALCULATOR_MIN = 0
export const CALCULATOR_MAX = 50_000_000
export const CALCULATOR_STEP = 25_000
export const CALCULATOR_DEFAULT = 1_000_000

export function calculateBrokerageSavings(propertyValue: number) {
  return Math.round(propertyValue * BROKERAGE_RATE)
}

export function formatCalculatorAmount(value: number) {
  return `₹ ${value.toLocaleString('en-IN')}`
}
